export const i18n = {
  en: {
    '%s days': {
      one: '%s day',
      other: '%s days'
    },
    'Spend %s nights in %s': {
      one: 'Spend %s night in %s',
      other: 'Spend %s nights in %s'
    },
    'Go from %s to %s in %s simple steps.': {
      one: 'Go from %s to %s in %s simple step.',
      other: 'Go from %s to %s in %s simple steps.'
    }
  },
  sv: {
    '%s days': {
      one: '%s dag',
      other: '%s dagar'
    },
    'Spend %s nights in %s': {
      one: '%s natt i %s',
      other: '% nätter i %s'
    },
    'Show more': 'Visa mer',
    '%s to %s by night train': '%s till %s med nattåg',
    'Day %s': 'Dag %s',
    'Available in other languages': 'Tillgänglig på fler språk',
    'See the travel guide in %s.': 'Se reseguiden på %s.',
    'A step-by-step travel guide': 'En reseguide',
    'Take the night train from %s to %s': 'Ta nattåget från %s till %s',
    'Take the train from %s to %s': 'Ta tåget från %s till %s',
    'Good to know when traveling from %s to %s':
      'Bra att veta när du reser från %s till %s',
    'There are other ways to travel': 'Det finns flera resvägar',
    'via %s': 'via %s',
    'by night train': 'med nattåg',
    direct: 'direkt',
    'See routes from %s to %s traveling %s.':
      'Se resvägar från %s till %s som går %s.',
    'Planning for the opposite direction?':
      'Planerar du att resa åt andra hållet?',
    'Travel from %s to %s': 'Resa från %s till %s',
    'See the %s page.': 'Se %s sidan.',
    'Popular trips from %s': 'Populära resor från %s',
    'Popular train tips': 'Populära tågtips',
    Popular: 'Populärt',
    'See route': 'Se resväg',
    '%s to %s by train': '%s till %s med tåg',
    'Go from %s to %s in %s simple steps.': {
      one: 'Åk från %s till %s i %s enkelt steg.',
      other: 'Åk från %s till %s i %s enkela steg.'
    },
    'Get the best train route to %s from %s.':
      'Få den bästa tågrutten till %s från %s.',
    'Learn how to best travel from %s to %s by train.':
      'Lär dig hur du bäst reser från %s till %s med tåg.',
    '%s to %s': '%s till %s',
    'from ': 'från ',
    'Trains from %s to %s': 'Tåg från %s till %s',
    'Find tickets': 'Hitta biljetter',
    'Price fr.': 'Pris fr.',
    'Arrive at your final destination, %s.':
      'Framme vid din slutdestination, %s.',
    'stopping by %s': 'stannar i %s',
    'arriving well rested': 'ankommer utvilad',
    'pass through %s': 'passera %s',
    'get a good nights rest': 'få en god natts sömn',
    'pass %s': 'passera %s',
    'Traveling from %s to %s by night train is the fastest and most comfortable option.':
      'Att resa från %s till %s med nattåg är det snabbaste och mest bekväma alternativet.',
    'Taking the night train from %s to %s is a great and comfortable choice.':
      'Att ta nattåget från %s till %s är ett bra och bekvämt val.',
    "Go by night train from %s to %s and arrive rested after a good night's sleep.":
      'Åk med nattåg från %s till %s och ankom utvilad efter en god natts sömn.',
    "It's a %s train journey, taking you quickly to your destination, %s.":
      'Det är en %s tågresa som snabbt tar dig till din destination, %s.',
    'You will %s before reaching your destination on this %s long train journey.':
      'Du kommer %s innan du når din destination på denna %s långa tågresa.',
    'This train route takes %s and you will %s on the way to your destination.':
      'Denna tågrutt tar %s och du kommer %s på väg till din destination.',
    'Traveling from %s to %s by train is a great experience.':
      'Att resa med tåg från %s till %s är en fantastisk upplevelse.',
    'Traveling by train from %s to %s is an unforgettable journey.':
      'Att resa med tåg från %s till %s är en oförglömlig resa.',
    'The trip from %s to %s by train is fantastic.':
      'Resan från %s till %s med tåg är fantastisk.',
    "It's a %s train journey with amazing scenery, stopping by %s on the way.":
      'Det är en %s tågresa med fantastisk utsikt, som stannar i %s på vägen.',
    "You'll pass through %s. It's a %s long train ride with beautiful scenery.":
      'Du kommer att resa via %s. Det är en %s lång tågresa genom vackra landskap.',
    'The journey takes %s, through beautiful landscapes, stopping in %s on the way.':
      'Resan tar %s, genom vackra landskap, med stopp i %s på vägen.',
    'Recommended routes': 'Rekommenderade resvägar',
    'Get inspiration, explore expert routes and easily book train tickets to your next sustainable European adventure.':
      'Hitta inspiration, utforska expertrutter och boka tågbiljetter till ditt nästa hållbara europeiska äventyr.'
  },
  de: {
    '%s days': {
      one: '%s Tag',
      other: '%s Tage'
    },
    'Spend %s nights in %s': {
      one: '%s Nacht in %s',
      other: '%s Nächte in %s'
    },
    'Show more': 'Mehr anzeigen',
    '%s to %s by night train': '%s nach %s mit dem Nachtzug',
    'Day %s': 'Tag %s',
    'Available in other languages': 'In weiteren Sprachen verfügbar',
    'See the travel guide in %s.': 'Siehe den Reiseführer auf %s.',
    'A step-by-step travel guide': 'Ein schrittweiser Reiseführer',
    'Take the night train from %s to %s':
      'Nehmen Sie den Nachtzug von %s nach %s',
    'Take the train from %s to %s': 'Nehmen Sie den Zug von %s nach %s',
    'Good to know when traveling from %s to %s':
      'Gut zu wissen bei Reisen von %s nach %s',
    'There are other ways to travel': 'Es gibt andere Reisemöglichkeiten',
    'via %s': 'über %s',
    'by night train': 'mit dem Nachtzug',
    direct: 'direkt',
    'See routes from %s to %s traveling %s.':
      'Sehen Sie Routen von %s nach %s, die %s reisen.',
    'Planning for the opposite direction?':
      'Planung in die entgegengesetzte Richtung?',
    'Travel from %s to %s': 'Reisen von %s nach %s',
    'See the %s page.': 'Siehe die Seite %s.',
    'Popular trips from %s': 'Beliebte Reisen von %s',
    'Popular train tips': 'Beliebte Zugtipps',
    Popular: 'Beliebt',
    'See route': 'Route anzeigen',
    '%s to %s by train': '%s nach %s mit dem Zug',
    'Go from %s to %s in %s simple steps.': {
      one: 'Gehen Sie von %s nach %s in %s einfachen Schritt.',
      other: 'Gehen Sie von %s nach %s in %s einfachen Schritten.'
    },
    'Get the best train route to %s from %s.':
      'Erhalten Sie die beste Zugverbindung zu %s von %s.',
    'Learn how to best travel from %s to %s by train.':
      'Lernen Sie, wie Sie am besten mit dem Zug von %s nach %s reisen.',
    '%s to %s': '%s nach %s',
    'from ': 'von ',
    'Trains from %s to %s': 'Züge von %s nach %s',
    'Find tickets': 'Tickets finden',
    'Price fr.': 'Preis ab',
    'Arrive at your final destination, %s.': 'Ankunft am Zielort, %s.',
    'stopping by %s': 'mit Zwischenstopp in %s',
    'arriving well rested': 'ausgeruht ankommen',
    'pass through %s': 'durchfahren %s',
    'get a good nights rest': 'eine gute Nachtruhe bekommen',
    'pass %s': 'durchfahren %s',
    'Traveling from %s to %s by night train is the fastest and most comfortable option.':
      'Die Reise von %s nach %s mit dem Nachtzug ist die schnellste und bequemste Option.',
    'Taking the night train from %s to %s is a great and comfortable choice.':
      'Mit dem Nachtzug von %s nach %s zu fahren ist eine großartige und bequeme Wahl.',
    "Go by night train from %s to %s and arrive rested after a good night's sleep.":
      'Fahren Sie mit dem Nachtzug von %s nach %s und kommen Sie ausgeruht nach einer guten Nacht Schlaf an.',
    "It's a %s train journey, taking you quickly to your destination, %s.":
      'Es ist eine %s Zugreise, die Sie schnell zu Ihrem Zielort, %s, bringt.',
    'You will %s before reaching your destination on this %s long train journey.':
      'Sie werden %s, bevor Sie auf dieser %s langen Zugreise Ihr Ziel erreichen.',
    'This train route takes %s and you will %s on the way to your destination.':
      'Diese Zugroute dauert %s und Sie werden %s auf dem Weg zu Ihrem Ziel.',
    'Traveling from %s to %s by train is a great experience.':
      'Mit dem Zug von %s nach %s zu reisen ist eine großartige Erfahrung.',
    'Traveling by train from %s to %s is an unforgettable journey.':
      'Mit dem Zug von %s nach %s zu reisen ist eine unvergessliche Reise.',
    'The trip from %s to %s by train is fantastic.':
      'Die Zugfahrt von %s nach %s ist fantastisch.',
    "It's a %s train journey with amazing scenery, stopping by %s on the way.":
      'Es ist eine %s Zugreise mit atemberaubender Landschaft, mit Zwischenstopps bei %s unterwegs.',
    "You'll pass through %s. It's a %s long train ride with beautiful scenery.":
      'Sie werden durch %s fahren. Es ist eine %s lange Zugfahrt mit schöner Landschaft.',
    'The journey takes %s, through beautiful landscapes, stopping in %s on the way.':
      'Die Reise dauert %s, durch wunderschöne Landschaften, mit Zwischenstopps in %s unterwegs.',
    'Recommended routes': 'Empfohlene Routen',
    'Get inspiration, explore expert routes and easily book train tickets to your next sustainable European adventure.':
      'Holen Sie sich Inspiration, erkunden Sie Expertenrouten und buchen Sie einfach Zugtickets für Ihr nächstes nachhaltiges europäisches Abenteuer.',
    AT: 'Österreich',
    BA: 'Bosnien und Herzegowina',
    BE: 'Belgien',
    BG: 'Bulgarien',
    BY: 'Weißrussland',
    CH: 'Schweiz',
    CZ: 'Tschechien',
    DE: 'Deutschland',
    DK: 'Dänemark',
    EE: 'Estland',
    ES: 'Spanien',
    FI: 'Finnland',
    FR: 'Frankreich',
    GB: 'Großbritannien',
    GR: 'Griechenland',
    HR: 'Kroatien',
    HU: 'Ungarn',
    IE: 'Irland',
    IT: 'Italien',
    KZ: 'Kasachstan',
    LT: 'Litauen',
    LU: 'Luxembourg',
    LV: 'Lettland',
    MC: 'Monaco',
    MD: 'Moldawien',
    ME: 'Montenegro',
    MK: 'Mazedonien',
    NL: 'Niederlande',
    NO: 'Norwegen',
    PL: 'Polen',
    PT: 'Portugal',
    RO: 'Rumänien',
    RS: 'Serbien',
    RU: 'Russland',
    SE: 'Schweden',
    SI: 'Slowenien',
    SK: 'Slowakei',
    TR: 'Tyrkiet',
    UA: 'Ukraine'
  },
  fr: {
    '%s days': {
      one: '%s jour',
      other: '%s jours'
    },
    'Spend %s nights in %s': {
      one: 'Passez %s nuit à %s',
      other: 'Passez % nuits à %s'
    },
    'Show more': 'Afficher plus',
    '%s to %s by night train': '%s à %s par train de nuit',
    'Day %s': 'Jour %s',
    'Available in other languages': 'Disponible dans plus de langues',
    'See the travel guide in %s.': 'Consultez le guide de voyage en %s.',
    'A step-by-step travel guide': 'Un guide de voyage étape par étape',
    'Take the night train from %s to %s': 'Prenez le train de nuit de %s à %s',
    'Take the train from %s to %s': 'Prenez le train de %s à %s',
    'Good to know when traveling from %s to %s':
      'Bon à savoir lors du voyage de %s à %s',
    'There are other ways to travel': "Il existe d'autres moyens de voyager",
    'via %s': 'via %s',
    'by night train': 'par train de nuit',
    direct: 'direct',
    'See routes from %s to %s traveling %s.':
      'Voyez les itinéraires de %s à %s en voyageant %s.',
    'Planning for the opposite direction?':
      'Vous planifiez dans le sens inverse ?',
    'Travel from %s to %s': 'Voyage de %s à %s',
    'See the %s page.': 'Consultez la page %s.',
    'Popular trips from %s': 'Voyages populaires depuis %s',
    'Popular train tips': 'Conseils populaires pour le train',
    Popular: 'Populaire',
    'See route': 'Voir l’itinéraire',
    '%s to %s by train': '%s à %s en train',
    'Go from %s to %s in %s simple steps.': {
      one: 'Allez de %s à %s en %s étape simple.',
      other: 'Allez de %s à %s en %s étapes simples.'
    },
    'Get the best train route to %s from %s.':
      'Obtenez le meilleur itinéraire pour %s depuis %s.',
    'Learn how to best travel from %s to %s by train.':
      'Apprenez comment voyager au mieux de %s à %s en train.',
    '%s to %s': '%s à %s',
    'from ': 'de ',
    'Trains from %s to %s': 'Trains de %s à %s',
    'Find tickets': 'Chercher billets',
    'Price fr.': 'Prix dès',
    'Arrive at your final destination, %s.':
      'Arrivez à votre destination finale, %s.',
    'stopping by %s': 'en faisant escale à %s',
    'arriving well rested': 'en arrivant bien reposé',
    'pass through %s': 'passer par %s',
    'get a good nights rest': 'bien se reposer la nuit',
    'pass %s': 'passer %s',
    'Traveling from %s to %s by night train is the fastest and most comfortable option.':
      'Voyager de %s à %s par train de nuit est l’option la plus rapide et la plus confortable.',
    'Taking the night train from %s to %s is a great and comfortable choice.':
      'Prendre le train de nuit de %s à %s est un choix excellent et confortable.',
    "Go by night train from %s to %s and arrive rested after a good night's sleep.":
      'Voyagez en train de nuit de %s à %s et arrivez reposé après une bonne nuit de sommeil.',
    "It's a %s train journey, taking you quickly to your destination, %s.":
      'C’est un voyage en train de %s, vous amenant rapidement à votre destination, %s.',
    'You will %s before reaching your destination on this %s long train journey.':
      'Vous %s avant d’atteindre votre destination sur ce voyage en train de %s.',
    'This train route takes %s and you will %s on the way to your destination.':
      'Cette route en train prend %s et vous %s en chemin vers votre destination.',
    'Traveling from %s to %s by train is a great experience.':
      'Voyager de %s à %s en train est une excellente expérience.',
    'Traveling by train from %s to %s is an unforgettable journey.':
      'Voyager en train de %s à %s est un voyage inoubliable.',
    'The trip from %s to %s by train is fantastic.':
      'Le trajet de %s à %s en train est fantastique.',
    "It's a %s train journey with amazing scenery, stopping by %s on the way.":
      'C’est un voyage en train de %s avec des paysages incroyables, en s’arrêtant à %s en chemin.',
    "You'll pass through %s. It's a %s long train ride with beautiful scenery.":
      'Vous passerez par %s. C’est un trajet en train de %s avec de beaux paysages.',
    'The journey takes %s, through beautiful landscapes, stopping in %s on the way.':
      'Le voyage dure %s, à travers de beaux paysages, avec des arrêts à %s en chemin.',
    'Recommended routes': 'Itinéraires recommandés',
    'Get inspiration, explore expert routes and easily book train tickets to your next sustainable European adventure.':
      'Trouvez de l’inspiration, explorez des itinéraires d’experts et réservez facilement des billets de train pour votre prochaine aventure européenne durable.',
    AT: "l'Autriche",
    BA: 'la Bosnie-Herzégovine',
    BE: 'la Belgique',
    BG: 'la Bulgarie',
    BY: 'la Biélorussie',
    CH: 'la Suisse',
    CZ: 'la République tchèque',
    DE: "l'Allemagne",
    DK: 'le Danemark',
    EE: "l'Estonie",
    ES: "l'Espagne",
    FI: 'la Finlande',
    FR: 'la France',
    GB: 'le Royaume-Uni',
    GR: 'la Grèce',
    HR: 'la Croatie',
    HU: 'la Hongrie',
    IE: "l'Irlande",
    IT: "l'Italie",
    KZ: 'le Kazakhstan',
    LT: 'la Lituanie',
    LU: 'le Luxembourg',
    LV: 'la Lettonie',
    MC: 'Monaco',
    MD: 'la Moldavie',
    ME: 'le Monténégro',
    MK: 'la Macédoine',
    NL: 'les Pays-Bas',
    NO: 'la Norvège',
    PL: 'la Pologne',
    PT: 'le Portugal',
    RO: 'la Roumanie',
    RS: 'la Serbie',
    RU: 'la Russie',
    SE: 'la Suède',
    SI: 'la Slovénie',
    SK: 'la Slovaquie',
    TR: 'la Turquie',
    UA: "l'Ukraine"
  },
  es: {
    '%s days': {
      one: '%s día',
      other: '%s días'
    },
    'Spend %s nights in %s': {
      one: 'Pasa %s noche en %s',
      other: 'Pasa % noches en %s'
    },
    'Show more': 'Ver más',
    '%s to %s by night train': '%s a %s en tren nocturno',
    'Day %s': 'Día %s',
    'Available in other languages': 'Disponible en más idiomas',
    'See the travel guide in %s.': 'Consulta la guía de viaje en %s.',
    'A step-by-step travel guide': 'Una guía de viaje paso a paso',
    'Take the night train from %s to %s': 'Toma el tren nocturno de %s a %s',
    'Take the train from %s to %s': 'Toma el tren de %s a %s',
    'Good to know when traveling from %s to %s':
      'Bueno saberlo al viajar de %s a %s',
    'There are other ways to travel': 'Hay otras formas de viajar',
    'via %s': 'vía %s',
    'by night train': 'en tren nocturno',
    direct: 'directo',
    'See routes from %s to %s traveling %s.':
      'Ve rutas de %s a %s viajando %s.',
    'Planning for the opposite direction?': '¿Planeas en la dirección opuesta?',
    'Travel from %s to %s': 'Viaje de %s a %s',
    'See the %s page.': 'Consulta la página de %s.',
    'Popular trips from %s': 'Viajes populares desde %s',
    'Popular train tips': 'Consejos populares de tren',
    Popular: 'Popular',
    'See route': 'Ver ruta',
    '%s to %s by train': '%s a %s en tren',
    'Go from %s to %s in %s simple steps.': {
      one: 'Ve de %s a %s en %s paso sencillo.',
      other: 'Ve de %s a %s en %s pasos sencillos.'
    },
    'Get the best train route to %s from %s.':
      'Consigue la mejor ruta de tren para %s desde %s.',
    'Learn how to best travel from %s to %s by train.':
      'Aprende cómo viajar mejor de %s a %s en tren.',
    '%s to %s': '%s a %s',
    'from ': 'desde ',
    'Trains from %s to %s': 'Trenes de %s a %s',
    'Find tickets': 'Buscar boletos',
    'Price fr.': 'Precio desde',
    'Arrive at your final destination, %s.': 'Llega a tu destino final, %s.',
    'stopping by %s': 'haciendo parada en %s',
    'arriving well rested': 'llegando bien descansado',
    'pass through %s': 'pasar por %s',
    'get a good nights rest': 'consigue un buen descanso nocturno',
    'pass %s': 'pasar %s',
    'Traveling from %s to %s by night train is the fastest and most comfortable option.':
      'Viajar de %s a %s en tren nocturno es la opción más rápida y cómoda.',
    'Taking the night train from %s to %s is a great and comfortable choice.':
      'Tomar el tren nocturno de %s a %s es una excelente y cómoda elección.',
    "Go by night train from %s to %s and arrive rested after a good night's sleep.":
      'Viaja en tren nocturno de %s a %s y llega descansado después de una buena noche de sueño.',
    "It's a %s train journey, taking you quickly to your destination, %s.":
      'Es un viaje en tren de %s, llevándote rápidamente a tu destino, %s.',
    'You will %s before reaching your destination on this %s long train journey.':
      'Tú %s antes de llegar a tu destino en este viaje en tren de %s.',
    'This train route takes %s and you will %s on the way to your destination.':
      'Esta ruta de tren toma %s y tú %s en camino a tu destino.',
    'Traveling from %s to %s by train is a great experience.':
      'Viajar de %s a %s en tren es una gran experiencia.',
    'Traveling by train from %s to %s is an unforgettable journey.':
      'Viajar en tren de %s a %s es un viaje inolvidable.',
    'The trip from %s to %s by train is fantastic.':
      'El viaje de %s a %s en tren es fantástico.',
    "It's a %s train journey with amazing scenery, stopping by %s on the way.":
      'Es un viaje en tren de %s con paisajes increíbles, haciendo paradas en %s en el camino.',
    "You'll pass through %s. It's a %s long train ride with beautiful scenery.":
      'Pasarás por %s. Es un viaje en tren de %s con hermosos paisajes.',
    'The journey takes %s, through beautiful landscapes, stopping in %s on the way.':
      'El viaje dura %s, a través de hermosos paisajes, haciendo paradas en %s en el camino.',
    'Recommended routes': 'Rutas recomendadas',
    'Get inspiration, explore expert routes and easily book train tickets to your next sustainable European adventure.':
      'Obtén inspiración, explora rutas expertas y reserva fácilmente billetes de tren para tu próxima aventura europea sostenible.',
    AT: 'Austria',
    BA: 'Bosnia y Herzegovina',
    BE: 'Bélgica',
    BG: 'Bulgaria',
    BY: 'Bielorrusia',
    CH: 'Suiza',
    CZ: 'Republica checa',
    DE: 'Alemania',
    DK: 'Dinamarca',
    EE: 'Estonia',
    ES: 'España',
    FI: 'Finlandia',
    FR: 'Francia',
    GB: 'Reino Unido',
    GR: 'Grecia',
    HR: 'Croacia',
    HU: 'Hungría',
    IE: 'Irlanda',
    IT: 'Italia',
    KZ: 'Kazajstán',
    LT: 'Lituania',
    LU: 'Luxemburgo',
    LV: 'Letonia',
    MC: 'Mónaco',
    MD: 'Moldavia',
    ME: 'Montenegro',
    MK: 'Macedonia',
    NL: 'Holanda',
    NO: 'Noruega',
    PL: 'Polonia',
    PT: 'Portugal',
    RO: 'Rumania',
    RS: 'Serbia',
    RU: 'Rusia',
    SE: 'Suecia',
    SI: 'Eslovenia',
    SK: 'Eslovaquia',
    TR: 'Turquía',
    UA: 'Ucrania'
  }
}
